"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _element = _interopRequireDefault(require("../form-ui/element"));

var _select = _interopRequireDefault(require("./select"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var propTypes = {
  /** A boolean to represent whether the input field should be disabled */
  bottomLabel: _propTypes.node,

  /** A boolean to represent whether the input field has a status of error */
  disabled: _propTypes.bool,

  /** A boolean to represent whether the input field has a status of success */
  error: _propTypes.bool,

  /** onBlur event handler - used to process the event */
  id: _propTypes.string,
  // check if search is open
  isSearch: _propTypes.bool,

  /** onChange event handler - used to process the event */
  label: _propTypes.node,

  /** onFocus event handler - used to process the event */
  onBlur: _propTypes.func,

  /** String for input field id */
  onChange: _propTypes.func,

  /** Label for the input field */
  onFocus: _propTypes.func,

  /** Label for the input field */
  options: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.object]),
  // Select pattern to match
  pattern: _propTypes.string,

  /** Label for the input field */
  placeholder: _propTypes.string,

  /** List of options, either array or object  */
  required: _propTypes.bool,

  /** Placeholder text to show while input is empty */
  success: _propTypes.bool,

  /** A boolean to represent whether the input field should be validated */
  topLabel: _propTypes.node,

  /** Value for the text input - managed outside the component */
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
};
var defaultProps = {
  disabled: false,
  error: false,
  success: false
};

var SelectComponent = function SelectComponent(props) {
  var disabled = props.disabled,
      id = props.id,
      isSearch = props.isSearch,
      onChange = props.onChange,
      options = props.options,
      label = props.label,
      pattern = props.pattern,
      placeholder = props.placeholder,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      required = props.required,
      value = props.value;

  var _useFocus = (0, _utils.useFocus)(false, onBlur, onFocus),
      hasFocus = _useFocus[0],
      handleBlur = _useFocus[1],
      handleFocus = _useFocus[2];

  var hasLabel = label && label.length > 0;
  var showValue = !label || hasFocus || value;
  return /*#__PURE__*/_react["default"].createElement(_element["default"], _extends({
    glyphRight: isSearch ? "search" : "caret-down",
    hasFocus: hasFocus,
    showValue: showValue
  }, props), /*#__PURE__*/_react["default"].createElement(_select["default"], {
    disabled: disabled,
    fieldId: id,
    handleBlur: handleBlur,
    handleChange: onChange,
    handleFocus: handleFocus,
    hasLabel: hasLabel,
    options: options,
    pattern: pattern,
    placeholder: placeholder,
    required: required,
    showValue: showValue,
    value: value
  }));
};

SelectComponent.propTypes = propTypes;
SelectComponent.defaultProps = defaultProps;
SelectComponent.displayName = "Modules.SelectComponent";
var _default = SelectComponent;
exports["default"] = _default;